// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Базовые стили виджета */
.misoft-chat-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

/* Кнопка переключения чата */
.misoft-chat-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #F18408;
  color: #FFFFFF;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(26, 59, 83, 0.35);
  transition: all 0.3s ease;
  font-size: 15px;
  font-weight: 500;
}

.misoft-chat-toggle:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(26, 59, 83, 0.45);
  background: #234a6a;
}

.misoft-chat-toggle-open {
  border-radius: 50%;
  padding: 14px;
  width: 56px;
  height: 56px;
  justify-content: center;
}

.misoft-chat-toggle-text {
  white-space: nowrap;
}

.misoft-chat-toggle-open .misoft-chat-toggle-text {
  display: none;
}

/* Контейнер чата */
.misoft-chat-container {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 380px;
  height: 550px;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Шапка чата */
.misoft-chat-header {
  background: #F18408;
  color: #FFFFFF;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.misoft-chat-header-content {
  flex: 1;
}

.misoft-chat-status {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  font-size: 13px;
  opacity: 0.95;
}

.misoft-status-indicator {
  width: 8px;
  height: 8px;
  background: #7bc67e;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.misoft-chat-status-connecting .misoft-status-indicator,
.misoft-chat-status-reconnecting .misoft-status-indicator {
  background: #fbbf24;
  animation: pulse 1s infinite;
}

.misoft-chat-status-error .misoft-status-indicator {
  background: #ef4444;
  animation: none;
}

.misoft-chat-status-disconnected .misoft-status-indicator {
  background: #94a3b8;
  animation: none;
}

/* Блок ошибки */
.misoft-chat-error {
  padding: 10px 16px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 13px;
  border-bottom: 1px solid #fecaca;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.misoft-chat-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.misoft-chat-close {
  background: transparent;
  border: none;
  color: #FFFFFF;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.misoft-chat-close:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* Область сообщений */
.misoft-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #FFFFFF;
}

.misoft-chat-messages::-webkit-scrollbar {
  width: 6px;
}

.misoft-chat-messages::-webkit-scrollbar-track {
  background: #F5F5F5;
}

.misoft-chat-messages::-webkit-scrollbar-thumb {
  background: #E0E0E0;
  border-radius: 3px;
}

/* Приветственное сообщение */
.misoft-chat-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: #778DA9;
}

.misoft-welcome-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.misoft-chat-welcome h4 {
  margin: 0 0 8px;
  font-size: 20px;
  color: #F18408;
}

.misoft-chat-welcome p {
  margin: 0;
  font-size: 14px;
  max-width: 250px;
}

/* Сообщения */
.misoft-message {
  margin-bottom: 16px;
  display: flex;
  animation: messageAppear 0.3s ease;
}

@keyframes messageAppear {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* direction === 1 — слева */
.misoft-message-direction-1 {
  justify-content: flex-start;
}

.misoft-message-direction-1 .misoft-message-content {
  background: #F5F5F5;
  color: #333333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

/* direction === -1 — справа */
.misoft-message-direction-n1 {
  justify-content: flex-end;
}

.misoft-message-direction-n1 .misoft-message-content {
  background: #FDD874;
  color: #333333;
  border-bottom-right-radius: 4px;
}

.misoft-message-content {
  max-width: 75%;
  padding: 12px 16px;
  border-radius: 12px;
  word-wrap: break-word;
}

.misoft-message-content p {
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.5;
}

/* Markdown внутри сообщений */
.misoft-message-markdown {
  font-size: 14px;
  line-height: 1.5;
}

.misoft-message-markdown p:first-child {
  margin-top: 0;
}

.misoft-message-markdown p:last-child {
  margin-bottom: 0;
}

.misoft-message-markdown strong {
  font-weight: 600;
}

.misoft-message-markdown em {
  font-style: italic;
}

.misoft-message-markdown code {
  background: rgba(0, 0, 0, 0.08);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
}

.misoft-message-markdown pre {
  margin: 8px 0;
  padding: 10px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow-x: auto;
}

.misoft-message-markdown pre code {
  background: none;
  padding: 0;
}

.misoft-message-markdown ul,
.misoft-message-markdown ol {
  margin: 6px 0;
  padding-left: 20px;
}

.misoft-message-markdown li {
  margin: 2px 0;
}

.misoft-message-markdown a {
  color: #337AB7;
  text-decoration: none;
}

.misoft-message-markdown a:hover {
  text-decoration: underline;
}

.misoft-message-markdown h1,
.misoft-message-markdown h2,
.misoft-message-markdown h3 {
  margin: 10px 0 6px;
  font-size: 1em;
  font-weight: 600;
}

.misoft-message-time {
  font-size: 11px;
  color: #778DA9;
}

/* Запрос имени */
.misoft-chat-name-form {
  background: #FFF8EE;
  border-top: 1px solid #F18408;
  padding: 12px 16px;
}

.misoft-chat-name-prompt {
  margin: 0 0 8px;
  font-size: 14px;
  color: #333333;
  font-weight: 500;
}

.misoft-chat-name-row {
  display: flex;
  gap: 8px;
}

.misoft-chat-name-input {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #EAEAEA;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #333333;
}

.misoft-chat-name-input:focus {
  outline: none;
  border-color: #F18408;
}

.misoft-chat-name-submit {
  padding: 10px 14px;
  background: #F18408;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.misoft-chat-name-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Нижняя панель: мессенджеры + ввод */
.misoft-chat-bottom {
  background: #fafafa;
  border-top: 1px solid #e2e8f0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;
}

.misoft-chat-bottom,
.misoft-chat-bottom * {
  box-sizing: border-box;
}

.misoft-chat-messengers {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.misoft-chat-messenger-button {
  display: flex;
  flex: 1 1 calc(50% - 5px);
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  background: #ffffff;
  color: #333333;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  line-height: 1.2;
  white-space: nowrap;
}

.misoft-chat-messenger-button:hover {
  border-color: #bfbfbf;
}

.misoft-chat-messenger-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  overflow: hidden;
}

.misoft-chat-messenger-icon img {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
}

.misoft-chat-input-form {
  background: transparent;
  padding: 0;
}

.misoft-chat-input-container {
  display: flex;
  gap: 8px;
  align-items: center;
}

.misoft-chat-input {
  flex: 1;
  min-width: 0;
  height: 44px;
  min-height: 44px;
  max-height: 100px;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  overflow-y: auto;
  transition: border-color 0.2s;
  color: #333333;
  background: #ffffff;
}

.misoft-chat-input::placeholder {
  color: #94a3b8;
}

.misoft-chat-input:focus {
  outline: none;
  border-color: #3b82f6;
}

.misoft-chat-send-button {
  width: 44px;
  height: 44px;
  padding: 0;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 4px rgba(59, 130, 246, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;
}

.misoft-chat-send-button:hover:not(:disabled) {
  background: #2563eb;
}

.misoft-chat-send-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.misoft-chat-send-icon {
  width: 18px;
  height: 18px;
  overflow: visible;
  display: block;
}

.misoft-chat-send-icon svg {
  width: 18px;
  height: 18px;
  display: block;
}

/* Адаптивность */
@media (max-width: 480px) {
  .misoft-chat-widget {
    bottom: 10px;
    right: 10px;
    left: auto;
  }

  .misoft-chat-container {
    width: 100%;
    height: calc(100vh - 100px);
    max-height: 600px;
  }

  .misoft-chat-toggle-text {
    display: none;
  }

  .misoft-chat-toggle {
    border-radius: 50%;
    padding: 14px;
    width: 56px;
    height: 56px;
    justify-content: center;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
